export const checkIfAllFalse = values => {
  return values.every(val => !val);
};
